import { Col, FloatingLabel, FormControl, FormSelect, Row } from "react-bootstrap";
import CommonUtils from "../../../../utils/common";
import Validator from "../../../../services/Validator";
import CityAutocomplete from "../../../shared/CityAutocomplete";
import StreetAutocomplete from "../../../shared/StreetAutocomplete";

const AddressMask = ({data, setData, formError, setFormError, setPlaces}) => {

    const UTILS = new CommonUtils();
    const VALIDATOR = new Validator();

    const cityChangeHandler = (newVal) => {
        setFormError({});
        setData(prev => ({
            ...prev,
            city: newVal
        }));
    };

    const streetChangeHandler = (newVal) => {
        setFormError({});
        setData(prev => ({
            ...prev,
            street: newVal
        }));
    };

    return (
        <>
            <p className="text-muted">
                <small>
                    Adresse der Liegenschaft
                </small>
            </p>
            <Row>
                <Col xs="12" md="6" xl="6">
                    <FloatingLabel label="Land">
                        <FormSelect
                            value={data.country_id}
                            onChange={e => {setData(prev => ({...prev, country_id: e.target.value})); setFormError({})}}
                            isValid={data.country_id}
                            isInvalid={formError.country_id}
                        >
                            <option value="">Land auswählen</option>
                            {UTILS.odooCountryList.map(country => (
                                <option key={`opt-c-${country.id}`} value={country.id}>{country.name}</option>
                            ))}
                        </FormSelect>
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="6" xl="6" hidden={data.country_id === undefined || data.country_id !== "12"}>
                    <FloatingLabel label="Bundesland">
                        <FormSelect
                            value={data.state_id}
                            onChange={e => {setData(prev => ({...prev, state_id: e.target.value})); setFormError({})}}
                            isValid={data.country_id === "12" && data.state_id !== undefined && data.state_id !== ""}
                            isInvalid={formError.state_id}
                        >
                            <option value="">Bundesland auswählen</option>
                            {UTILS.odooStateATList.map(state => (
                                <option key={`opt-s-${state.id}`} value={state.id}>{state.name}</option>
                            ))}
                        </FormSelect>
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="4" xl="4">
                    <FloatingLabel label="PLZ">
                        <FormControl
                            placeholder="PLZ"
                            value={data.zip}
                            onChange={e => {setData(prev => ({...prev, zip: e.target.value})); setFormError({})}}
                            isValid={VALIDATOR.isValidZip(data.zip)}
                            isInvalid={formError.zip}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="8" xl="8">
                    <CityAutocomplete
                        zip={data.zip}
                        country={data.country_id}
                        city={data.city}
                        setCity={cityChangeHandler}
                        outsidePlaces={setPlaces}
                        isError={formError.city? true: false}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="9" xl="8">
                    <StreetAutocomplete
                        country={data.country_id}
                        zip={data.zip}
                        city={data.city}
                        street={data.street}
                        setStreet={streetChangeHandler}
                        isError={formError.street? true: false}
                    />
                </Col>
                <Col xs="6" md="3" xl="4">
                    <FloatingLabel label="Hausnummer">
                        <FormControl
                            placeholder="Hausnummer"
                            value={data.houseNr}
                            onChange={e => {setData(prev => ({...prev, houseNr: e.target.value})); setFormError({})}}
                            isValid={data.houseNr && data.houseNr !== ""}
                            isInvalid={formError.houseNr}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
        </>
    )
}
export default AddressMask;